import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../../fields/number/FormattedCurrencyValue';
import DATA_MINING_CONTROLLER from '../../../controllers/dataMining';
import { TableConfig } from '../../../utils/appConfig';
import NoData from '../../page/NoData';
import Pagination from '../../page/Pagination'
import GLLines from '../reportDefinition/GLStatusOverviewVRSideLines';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../../utils/logger';
import ApplicationMessages from '../../inAppMessages/ApplicationMessages';
import { TransactionReportTypeEnum } from '../../../utils/enums';

const log = new Logger('DATA_MINING_GL_STATUS_VR_SIDE_LINES_PAGE', LOG_LEVELS.DEBUG);

const GLStatusOverviewVRSideLinesColumnMapping = {
    "nr": "Nr", "reconStatus": "Status", "companyCode": "Company Code", "invoiceNumber": "Invoice Number", "transactionDate": "Transaction Date",
    "totalValueExclVAT": "Total Value excl VAT", "totalValueExclVAT2": "Total Value excl VAT 2", "totalValueExclVAT3": "Total Value excl VAT 3", "totalValueExclVAT4": "Total Value excl VAT 4",
    "totalValueExclVAT5": "Total Value excl VAT 5", "totalValue": "Total Value", "totalValue2": "Total Value 2", "totalValue3": "Total Value 3", "totalValue4": "Total Value 4",
    "currency": "Currency Key", "currency2": "Currency Key 2", "currency3": "Currency Key 3", "currency4": "Currency Key 4", "currency5": "Currency Key 5", "vatAmount": "VAT Amount", "vatAmount2": "VAT Amount 2",
    "vatAmount3": "VAT Amount 3", "vatAmount4": "VAT Amount 4", "vatAmount5": "VAT Amount 5"
};

const DEFAULT_PAGINATION_CONFIG = {
    pageNumber: 1,
    pageSize: TableConfig.REPORT_LEVEL_ONE_PAGE_SIZE,
    page:0,
    startAt: 1
};

export class GLStatusVRSidePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: TransactionReportTypeEnum.GLSTATUSVRSIDE.value
            },
            pagination: DEFAULT_PAGINATION_CONFIG,
            loading: true
        };
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
        this.onReconcileHandler = this.onReconcileHandler.bind(this);
    }

    getParameters(selection, pagination) {
        let params = {
            startAt: pagination.startAt,
            pageSize: pagination.pageSize,
            includeChildCompanies: selection.includeChildCompanies,
            companyCode: selection.companyCode,
            periodStartDate: selection.startDate,
            periodEndDate: selection.endDate,
            overviewType: selection.overviewType
        };
        return params;
    }

    getColumns() {
        var columnData = GLLines;
        log.debug('render(): columnData', columnData);
        const columns = columnData.map((item, id) => {
            log.debug('render(): item', item, item.Accessor, item.Header);
            return {
                id: item.Accessor,
                Header: props => <LanguageStringResolver string={item.Header} />,
                accessor: ((item.Accessor === 'Total Value excl VAT') || 
                           (item.Accessor === 'Total Value excl VAT 2') || 
                           (item.Accessor === 'Total Value excl VAT 3') || 
                           (item.Accessor === 'Total Value excl VAT 4') || 
                           (item.Accessor === 'Total Value excl VAT 5') || 
                           (item.Accessor === 'Total Value') ||
                           (item.Accessor === 'Total Value 2') ||
                           (item.Accessor === 'Total Value 3') ||
                           (item.Accessor === 'Total Value 4') ||
                           (item.Accessor === 'Total Value 5') ||
                           (item.Accessor === 'VAT Amount') ||
                           (item.Accessor === 'VAT Amount 2') ||
                           (item.Accessor === 'VAT Amount 3') ||
                           (item.Accessor === 'VAT Amount 4') ||
                           (item.Accessor === 'VAT Amount 5')) ?
                    d => <FormattedCurrencyValue value={d[item.Accessor]}></FormattedCurrencyValue> : item.Accessor,
                style: item.textAlign !== undefined ? { textAlign: "right" } : "",
                maxWidth: item.MaxWidth !== undefined ? item.MaxWidth : 1000,
            }
        })
        log.debug('render(): ', columns);
        return columns;
    }

    onFetchDataHandler(state) {
        log.debug('onFetchDataHandler(): ');
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.REPORT_LEVEL_ONE_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        const startAt = page * pageSize;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,            
            page: page,
            pageSize: pageSize,
            startAt: startAt + 1
        });

         //To set default/hidden properties of react table
         if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page = 0;
        }
        this.setState({
            pagination: pagination,
            viewTableState: state,
            loading: true
        });

        this.props.doGetGLStatusOverviewData(this.getParameters(this.props.filterCriteria, pagination), () => {
            let pagination = Object.assign({}, this.state.pagination);
            let invoiceData = this.props.invoiceData || [];
            let totalCount = (this.props.invoiceData && this.props.invoiceData.totalCount) || invoiceData.length;
            pagination.pages = pagination.pageSize === 0 ? totalCount : Math.ceil(totalCount / pagination.pageSize);
            this.setState({
                loading: false,
                pagination: pagination
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //when reportType is same and filters are updated/changed and clicked apply, need to call fetch data explicitely
        if (!nextProps.isReportTypeChanged && (nextProps.filterCriteria !== this.props.filterCriteria)) {
            this.props = nextProps;
            this.onFetchDataHandler(Object.assign({}, DEFAULT_PAGINATION_CONFIG, {pageSize: this.state.pagination.pageSize}));
        }
    }

    componentWillUnmount() {
        log.debug('componentWillUnmount()');
        log.clearDictionaryError(ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD);
        this.props.doUnload();
    }

    onReconcileHandler() {
        this.props.doGLReconciliation(() => {
            this.onFetchDataHandler(Object.assign({}, DEFAULT_PAGINATION_CONFIG, {pageSize: this.state.pagination.pageSize}));
        });
    }

    render() {
        log.debug('render() - props: ', this.props);
        log.setDictionaryMessage(ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD);
        let pagination = this.state.pagination || {};
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page =pagination.page;
        }
        const columns = this.getColumns();
        let invoiceData = (this.props.invoiceData && this.props.invoiceData.data) || [];
        for (var key in GLStatusOverviewVRSideLinesColumnMapping) {
            invoiceData = JSON.parse(JSON.stringify(invoiceData).split('"' + key + '":').join('"' + GLStatusOverviewVRSideLinesColumnMapping[key] + '":'));
        }

        let fileName = (this.state.selection && this.state.selection.reportType) ? this.state.selection.reportType.replace(' ', '') + '.csv' : "DataMining.csv";
        const NoDataComponent = props => (
            <NoData
                noDataText="transactionReports_NoData"
                {...props}
            />
        )

        return (
            <div data-test="component-gl-vr-lines-page">
                <ReactTable
                    manual
                    pages={pagination.pages || 1}
                    defaultPageSize={TableConfig.PAGINATION.REPORT_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.REPORT_PAGE_SIZE_OPTIONS}
                    ref={ref => this.viewTable = ref}
                    minRows={0}
                    maxRows={0}
                    data={invoiceData}
                    columns={columns}
                    loading={this.props.loading} // Display the loading overlay when we need it
                    onFetchData={this.onFetchDataHandler} // Request new data when things change
                    sortable={false}
                    showPageJump={true}
                    NoDataComponent={NoDataComponent}
                    className={_.isEmpty(invoiceData) ? 'mb30 hide-header' : 'mb30'}
                    PaginationComponent={Pagination}
                    showPagination={invoiceData.length === 0 ? false : true}
                />
                <span className="mt10">
                      <ApplicationMessages
                          messageIds={[ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD]}
                          messageType="applicationWarning"
                      />
                </span>
                <button className="primary" onClick={this.onReconcileHandler}><LanguageStringResolver string='dataMining_DoGLReconciliation' /></button>
                <CSVLink
                    data={sanitizeCsvData(invoiceData)}
                    filename={fileName}
                    className={invoiceData && invoiceData.length > 0 ? "button secondary" : "invisible"}>
                    <LanguageStringResolver string='viewTransmission_ExportToCSV' />
                </CSVLink>
            </div>
        );
    }
}


GLStatusVRSidePage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
}

function mapStateToProps(state) {
    return {
        languages: state.languages,
        invoiceData: (state.dataMining && state.dataMining.invoiceLines)
    }
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    dispatchProps.doGetGLStatusOverviewData = (params, callback) => {
        log.debug('doGetGLStatusOverviewData');
        dispatch(DATA_MINING_CONTROLLER.doGetGLStatusOverviewData(params, callback));
    },
    dispatchProps.doUnload = () => {
        dispatch(DATA_MINING_CONTROLLER.doUnloadGLData());
    },
    dispatchProps.doGLReconciliation = (callback) => {
        log.debug('doGLReconciliation');
        dispatch(DATA_MINING_CONTROLLER.doGLReconciliation(callback));
    }
    return dispatchProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(GLStatusVRSidePage);